"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAction = addAction;
exports.removeAction = removeAction;
var Actions = {};

exports.default = Actions;
function addAction(actionName, action) {
  Actions[actionName] = function (payload) {
    return action(payload);
  };
}

function removeAction(actionName) {
  delete Actions[actionName];
}


//////////////////
// WEBPACK FOOTER
// ./~/jumpstate/lib/actions.js
// module id = 191
// module chunks = 0